import { TransactionType } from 'lib/graphql/storeadmin'

export const ledgerReturnTypeCheck = (type: string) => {
  switch (type) {
    case 'IN':
      return TransactionType.In
    case 'OUT':
    default:
      return TransactionType.Out
  }
}

export const ledgerTypeCheck = (type: string) => {
  switch (type) {
    case TransactionType.Fix:
      return '赤伝'
    case TransactionType.In:
      return '入金'
    case TransactionType.Out:
    default:
      return '出金'
  }
}
